import { Building2Icon, ExternalLinkIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Button } from "@/components/ui/button";
import { dates } from "@/lib/dates";
import { CertificationType } from "@/types";

export const Certification = ({
  certification,
}: {
  certification: CertificationType;
}) => {
  /* Helpers */
  const dateDisplay =
    dates.prepareDateDisplayForCertificationOrEducationOrWorkExperience({
      startMonth: certification.startMonth,
      startYear: certification.startYear,
      endMonth: certification.endMonth,
      endYear: certification.endYear,
      current: undefined,
    });
  const name = certification.name?.trim();
  const organization = certification.organization?.trim();
  const hasCredentialId = !!certification.credentialId;

  /* Render */
  const render = () => {
    return (
      <Row className="items-start gap-4">
        <Row className="h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-50">
          <Building2Icon className="h-5 w-5 text-slate-400" />
        </Row>
        <Column className="min-w-0 flex-1 gap-0.5">
          <Row className="flex-wrap items-baseline justify-between gap-x-2">
            <Row className="flex-wrap items-baseline gap-x-2">
              {name ? (
                <Text className="text-sm font-medium text-slate-800">
                  {name}
                </Text>
              ) : (
                <Text className="text-sm font-medium italic text-red-400">
                  [Missing Name]
                </Text>
              )}
              {organization ? (
                <>
                  <Text className="text-slate-500">·</Text>
                  <Text className="text-sm font-light text-slate-500">
                    {organization}
                  </Text>
                </>
              ) : null}
            </Row>
            {certification.credentialUrl ? (
              <Button
                className="text-sm font-medium text-primary-900"
                onClick={() => {
                  window.open(
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                    certification.credentialUrl || undefined,
                    "_blank",
                  );
                }}
                variant="link"
              >
                <ExternalLinkIcon className="h-4 w-4" />
                View
              </Button>
            ) : null}
          </Row>
          {dateDisplay || hasCredentialId ? (
            <Row className="flex-wrap items-center gap-x-2 text-xs font-normal text-slate-500">
              {dateDisplay ? (
                <Text className="text-xs">{dateDisplay}</Text>
              ) : null}
              {dateDisplay && hasCredentialId ? (
                <Text className="text-slate-500">·</Text>
              ) : null}
              {hasCredentialId ? (
                <Text className="text-xs">
                  ID: {certification.credentialId}
                </Text>
              ) : null}
            </Row>
          ) : null}
        </Column>
      </Row>
    );
  };

  return render();
};
